import UserAddContent from "../content/userAddContent";
import Layout from "../layout/Layout";

const UserAdd = () => {
  return (
    <Layout>
      <UserAddContent />
    </Layout>
  );
};

export default UserAdd;
